import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";

export const getAccessToken = async (
  app: IPublicClientApplication,
  acc: AccountInfo,
  scope: string
) => {
  try {
    const auth = await app.acquireTokenSilent({
      scopes: [scope],
      account: acc
    });
    return auth.accessToken;
  } catch (error) {
    console.error(error);
    return null;
  }
};
